<div class="row justify-content-center">
    <div class="col-md-8 col-sm-12">
        <img src="/assets/images/nhs_wales_logo.png" height="200" alt="NHS Wales logo">
        <h2>NHS Wales - Eating Disorders Patients Census</h2>
        <h5>The data collection aims to quantify the number of patients currently in beds in Wales who have an eating disorder, and to quantify the level of demand and the complexity of the patients currently occupying a bed.</h5>
        <hr>
        <p>Please select your hospital from the drop-down list below and click <strong>Go to Survey</strong>. The following page will provide you with an introduction to the census and further guidance.</p>
        <div class="form-group mt-3">
            <select class="form-control" name="submissions" id="submissionSelection" (change)="selection = $event.target.value">
                <option value="-" disabled>Select your hospital...</option>
                <optgroup *ngFor="let g of submissions | groupBy: 'organisationName' | pairs" [label]="g[0]">
                    <option *ngFor="let submission of g[1]" [value]="submission.submissionId + '-' + submission.organisationId">{{ submission.submissionName }}</option>
                </optgroup>
            </select>
            <button class="btn btn-success mt-3" [disabled]="!selection" [routerLink]="'/edps/' + selection">Go to Survey</button>
        </div>
    </div>
</div>